import React from 'react'
import { ProgressBar } from '../../common/ProgressBar'
import { PostPollOption } from '../../../generated/api/post-row'

interface ResultBarProps {
  option: PostPollOption
  totalVotes: number
}

export const ResultBar = ({
  option,
  totalVotes,
}: ResultBarProps): React.ReactNode => {
  const percentage = totalVotes > 0 ? (option.votes / totalVotes) * 100 : 0

  return (
    <ProgressBar
      height="h-[50px]"
      backgroundColor="bg-brandGreen/60"
      percentage={percentage}
      number={option.votes}
      text={option.text}
      animate={option.viewerChose}
      duration={800}
    />
  )
}
